export enum HiddenAddonKeys {
  DPR = 'DPR',
  ASC = 'ASC',
  GCFA = 'GCFA',
  CYD = 'CYD',
  DSP = 'DSP',
  PT = 'PT',
  CYGD = 'CYGD',
  BS = 'BS',
  SI = 'SI',
  CSVE = 'CSVE',
  IMS = 'IMS',
  TM = 'TM',
  ADD = 'ADD',
  VA = 'VA',
  POS = 'POS',
  TW = 'TW',
  SP = 'SP',
  DP = 'DP',
  BSI = 'BSI',
  SIA = 'SIA',
  LPTD = 'LPTD',
  WWB = 'WWB',
  FTP = 'FTP',
  ED = 'ED',
  E = 'E',
  R = 'R',
  A = 'A',
  MD = 'MD',
  DT = 'DT',
  CL = 'CL',
  DG = 'DG',
  BD = 'BD',
  SMTP = 'SMTP',
  DBI = 'DBI',
  B = 'B',
  API = 'API',
  FBI = 'FBI',
  SPWE = 'SPWE',
  C = 'C',
  GP = 'GP',
  CSI = 'CSI',
  UFAS = 'UFAS',
  TR = 'TR',
  SPM = 'SPM',
  US = 'US'


}


export enum AddonKeys {
  PB = 'PB',
  ASC = 'ASC',
  GCFA = 'GCFA',
  CYD = 'CYD',
  CL = 'CL',
  DSP = 'DSP',
  PT = 'PT',
  MD = 'MD',
  CC = 'CC',
  CYGD = 'CYGD',
  DK = 'DK',
  BS = 'BS',
  SI = 'SI',
  CSVE = 'CSVE',
  POS = 'POS',
  FTP = 'FTP',
  IMS = 'IMS',
  GL = 'GL',
  CS = 'CS',
  R = 'R',
  TM = 'TM',
  ADD = 'ADD',
  TW = 'TW',
  ESP = 'ESP',
  SBI = 'SBI',
  NBI = 'NBI',
  IO = 'IO',
  VA = 'VA',
  A = 'A',
  TSR = 'TSR',
  AP = 'AP',
  ED = 'ED',
  E = 'E',
  SP = 'SP',
  AAD = 'AAD',
  DC = 'DC',
  DP = 'DP',
  BSI = 'BSI',
  SIA = 'SIA',
  TFA = 'TFA',
  LPTD = 'LPTD',
  PD = 'PD',
  HS = 'HS',
  MDD = 'MDD',
  HPDF = 'HPDF',
  VP = 'VP',
  DT = 'DT',
  DPR = 'DPR',
  DG = 'DG',
  SMTP = 'SMTP',
  BD = 'BD',
  STS = 'STS',
  WWB = 'WWB',
  US = 'US',
  DM = 'DM',
  IPR = 'IPR',
  LH = 'LH',
  SSO = 'SSO'
}